export default "__VITE_PUBLIC_ASSET__afab67b3__"